import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=42c99cae&scoped=true&"
import script from "./sidebar.ts?vue&type=script&lang=ts&"
export * from "./sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=42c99cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c99cae",
  null
  
)

export default component.exports